export default {
  modules: {
    map: {
      key: 'Map',
      namespace: 'esri/Map'
    },
    mapView: {
      key: 'MapView',
      namespace: 'esri/views/MapView'
    },
    extent: {
      key: 'Extent',
      namespace: 'esri/geometry/Extent'
    },
    geometryEngine: {
      key: 'GeometryEngine',
      namespace: 'esri/geometry/geometryEngine'
    },
    spatialReference: {
      key: 'SpatialReference',
      namespace: 'esri/geometry/SpatialReference'
    },
    webMercatorUtils: {
      key: 'WebMercatorUtils',
      namespace: 'esri/geometry/support/webMercatorUtils'
    },
    graphic: {
      key: 'Graphic',
      namespace: 'esri/Graphic'
    },
    graphicsLayer: {
      key: 'GraphicsLayer',
      namespace: 'esri/layers/GraphicsLayer'
    },
    sketchViewModel: {
      key: 'SketchViewModel',
      namespace: 'esri/widgets/Sketch/SketchViewModel'
    },
    featureLayer: {
      key: 'FeatureLayer',
      namespace: 'esri/layers/FeatureLayer'
    },
    config: {
      key: 'Config',
      namespace: 'esri/config'
    },
    polygon: {
      key: 'Polygon',
      namespace: 'esri/geometry/Polygon'
    },
    portalItem: {
      key: 'PortalItem',
      namespace: 'esri/portal/PortalItem'
    },
    point: {
      key: 'Point',
      namespace: 'esri/geometry/Point'
    },
    watchUtils: {
      key: 'WatchUtils',
      namespace: 'esri/core/watchUtils'
    },
    webMap: {
      key: 'WebMap',
      namespace: 'esri/WebMap'
    },
    basemap: {
      key: 'Basemap',
      namespace: 'esri/Basemap'
    },
    basemapStyle: {
      key: 'BasemapStyle',
      namespace: 'esri/support/BasemapStyle'
    },
    layerList: {
      key: 'LayerList',
      namespace: 'esri/widgets/LayerList'
    },
    expand: {
      key: 'Expand',
      namespace: 'esri/widgets/Expand'
    }
  },
  wkid: 102100,
  worldMapExtent: {
    xMin: -20037507.073813,
    yMin: -19971868.872273,
    xMax: 20037507.061556,
    yMax: 19971868.88453
  },
  AUS_Extent: {
    xmin: 12342439.331260854,
    ymin: -5642887.17612344,
    xmax: 17390952.175438832,
    ymax: -990623.88657571
  },
  AUS_Extent_BCK: {
    xmin: 16133582,
    xmax: 16140557,
    ymin: -4556430,
    ymax: -4549398
  },
  // Australia boundary for map constraints (Web Mercator WKID 102100)
  // This prevents users from panning outside Australia's boundaries
  // Note: Using the same coordinates as AUS_Extent for consistency
  AUS_Boundary_Constraint: {
    xmin: 96.761605, // Western boundary
    ymin: -46.306362, // Southern boundary
    xmax: 168.02119, // Eastern boundary
    ymax: -5.207922, // Northern boundary
    spatialReference: { wkid: 4326 } // WGS84
  },
  // Prevent zooming out too far
  mapMinScale: 35_000_000,
  polygonSymbol: {
    type: 'simple-fill',
    color: 'rgba(0, 112, 255, 0.25)',
    style: 'solid',
    outline: {
      color: 'rgba(0, 169, 230, 0.75)',
      width: 1
    }
  },
  polygonSymbolDarkCompleteDraw: {
    type: 'simple-fill',
    color: 'rgba(255, 255, 255, 0.5)',
    style: 'solid',
    outline: {
      color: 'rgba(255, 255, 255, 0.75)',
      width: 1
    }
  },
  polygonSymbolNoOutline: {
    type: 'simple-fill',
    color: 'rgba(0, 112, 255, 0.25)',
    style: 'solid',
    outline: {
      color: 'rgba(0, 112, 255, 0)',
      width: 1
    }
  },
  polygonDarkSymbol: {
    type: 'simple-fill',
    color: 'rgba(0, 89, 254, 0.25)',
    style: 'solid',
    outline: {
      color: 'rgba(0, 169, 230, 0.75)',
      width: 1
    }
  },
  pointSymbol: {
    type: 'simple-marker',
    color: 'rgba(0, 112, 255, 0.50)',
    size: '16px',
    outline: {
      color: 'rgba(0, 197, 255, 0.75)',
      width: 1
    }
  },
  pointDarkSymbol: {
    type: 'simple-marker',
    color: 'rgba(0, 112, 255, 0.95)',
    size: '16px',
    outline: {
      color: 'rgba(255, 255, 255, 0.90)',
      width: 1
    }
  },
  currentAOIlightOutlineSymbol: {
    type: 'simple-fill',
    style: 'solid',
    color: [0, 112, 255, 0.25],
    outline: {
      color: [0, 169, 230, 0.75],
      style: 'solid',
      width: 1
    }
  },
  currentAOIlightSymbol: {
    type: 'simple-fill',
    style: 'solid',
    color: [0, 112, 255, 0.25],
    outline: {
      color: [0, 169, 230, 0.75],
      style: 'solid',
      width: 0.5
    }
  },
  currentAOIDarkSymbol: {
    type: 'simple-fill',
    style: 'solid',
    color: [0, 89, 254, 0.35],
    outline: {
      color: [0, 169, 230, 0.75],
      style: 'solid',
      width: 0.5
    }
  },
  previewAOIlightSymbol: {
    type: 'simple-fill',
    style: 'solid',
    color: [0, 0, 0, 0.16],
    outline: {
      color: 'black',
      style: 'solid',
      width: 1
    }
  },
  previewAOIDarkSymbol: {
    type: 'simple-fill',
    style: 'solid',
    color: [250, 77, 86, 0.6],
    outline: {
      color: 'white',
      style: 'solid',
      width: 0.5
    }
  },
  shapeMinScale: 300000,
  zoomLevel: 17
};
